import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "6", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "19", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "18", r: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Divide";
const Divide = memo(themed(Icon));
export {
  Divide
};
//# sourceMappingURL=divide.js.map
